import Col from '@loggi/ui/components/col';
import gutterTypes from '@loggi/ui/components/col/types';
import Notification from '@loggi/ui/components/notification';
import colors from '@loggi/ui/components/utils/colors';
import PropTypes from 'prop-types';
import React from 'react';
import './card.styles.scss';

const defaultGutterValues = {
  top: 'onehalf',
  right: 'onehalf',
  left: 'onehalf',
  bottom: 'onehalf'
};

const gutterValuesWithNotification = {
  top: null,
  right: null,
  left: null,
  bottom: 'onehalf'
};

function Card(props) {
  const {
    className,
    backgroundColor,
    notificationMessage,
    notificationStyle,
    notificationIcon,
    children
  } = props;

  let { gutter } = props;

  if (notificationMessage) {
    gutter = gutterValuesWithNotification;
  }

  return (
    <Col
      flexDirection="column"
      gutter={gutter}
      className={className ? `card ${className}` : 'card'}
      backgroundColor={backgroundColor}
    >
      {notificationMessage && (
        <Notification
          inline
          style={notificationStyle}
          icon={notificationIcon}
          text={notificationMessage}
        />
      )}
      {children}
    </Col>
  );
}

Card.propTypes = {
  children: PropTypes.node,
  gutter: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(gutterTypes)]),
  className: PropTypes.string,
  backgroundColor: PropTypes.oneOf(colors.backgroundHexKeys),
  notificationMessage: PropTypes.string,
  notificationStyle: PropTypes.oneOf(colors.backgroundHexKeys),
  notificationIcon: PropTypes.string
};

Card.defaultProps = {
  children: null,
  backgroundColor: colors.type.WHITE,
  gutter: defaultGutterValues,
  className: null,
  notificationMessage: null,
  notificationStyle: null,
  notificationIcon: null
};

Card.displayName = 'Card';

export default Card;
